// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__6w-09","title":"Images90_title__-piYc","images":"Images90_images__2iV9g"};